/**
 * @file Automatically generated by barrelsby.
 */

export * from './onboarding.component';
